<ng-template [ngIf]="loading"><div class="loadingScreen"></div></ng-template>

<ng-template [ngIf]="schedules.length>0">
    <div droppable [draggable] class="workshift show-action" [dragData]="schedules" (onDrop)="onItemDrop($event)">

        <ng-template #errors>
            <ul>
                <li *ngFor="let msg of error.messages">{{msg}}</li>
            </ul>
        </ng-template>

        <ng-template [ngIf]="onHasErrors()">
            <div style="float: right;" class="emprez-orange-fiesta" placement="top" [ngbPopover]="errors" triggers="mouseenter:mouseleave">
                <i class="fa fa-exclamation-triangle"></i>
            </div>
        </ng-template>

        <ng-template [ngIf]="isAfterToday()">
            <div class="hidden-action" style="float: left;">
                <a class="naked muted" (click)="onAddEmployeeSchedule()"><i class="fad fa-plus"></i></a>
            </div>
        </ng-template>

        <div *ngFor="let bean of schedules; let idx=index">
            <ng-template #template>
                <span>{{bean.employee.fullName}}</span>
                <br>{{bean.startHour | myDateFormat:'LT'}}&nbsp;-&nbsp;{{bean.endHour | myDateFormat:'LT'}}

                <ng-template [ngIf]="bean.meal1">
                    <div>
                        {{'Meal1Label' | translate}}&nbsp;{{bean.meal1.start | myDateFormat:'LT'}}&nbsp;-&nbsp;{{bean.meal1.end | myDateFormat:'LT'}}
                        <ng-template [ngIf]="bean.meal1.paid">
                            <span>{{'MealPaid' | translate}}</span>
                        </ng-template>
                    </div>
                </ng-template>

                <ng-template [ngIf]="bean.meal2">
                    <div>
                        {{'Meal2Label' | translate}}&nbsp;{{bean.meal2.start | myDateFormat:'LT'}}&nbsp;-&nbsp;{{bean.meal2.end | myDateFormat:'LT'}}
                        <ng-template [ngIf]="bean.meal2.paid">
                            <span>{{'MealPaid' | translate}}</span>
                        </ng-template>
                    </div>
                </ng-template>

                <ng-template [ngIf]="bean.break1">
                    <div>{{'Break1Label' | translate}}&nbsp;{{bean.break1 | myDateFormat:'LT'}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.break2">
                    <div>{{'Break2Label' | translate}}&nbsp;{{bean.break2 | myDateFormat:'LT'}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.note">
                    <div>{{bean.note}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.function">
                    <div>{{bean.function}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task1">
                    <div>{{bean.task1}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task2">
                    <div>{{bean.task2}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task3">
                    <div>{{bean.task3}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task4">
                    <div>{{bean.task4}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task5">
                    <div>{{bean.task5}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task6">
                    <div>{{bean.task6}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task7">
                    <div>{{bean.task7}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task8">
                    <div>{{bean.task8}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task9">
                    <div>{{bean.task9}}</div>
                </ng-template>
                <ng-template [ngIf]="bean.task10">
                    <div>{{bean.task10}}</div>
                </ng-template>
            </ng-template>

            <div class="show-action" style="text-align: center;" [class.muted]="!isAfterToday()">
                <span (click)="onEditEmployeeSchedule(bean)" [class.unpublish]="!bean.active">{{explainSchedule(bean)}}</span>
                <ng-template [ngIf]="isAfterToday()">
                    <div class="hidden-action">
                        <ng-template [ngIf]="bean.hasDetails">
                            <span placement="top" [ngbPopover]="template" triggers="mouseenter:mouseleave">&nbsp;<i class="fa fa-info"></i></span>
                        </ng-template>
                        <ng-template [ngIf]="isMale(bean.employee)">
                            <a class="naked muted" (click)="onViewEmployee(bean.employee.id)">&nbsp;<i class="fa fa-male"></i></a>
                        </ng-template>
                        <ng-template [ngIf]="!isMale(bean.employee)">
                            <a class="naked muted" (click)="onViewEmployee(bean.employee.id)">&nbsp;<i class="fa fa-female"></i></a>
                        </ng-template>
                        <ng-template [ngIf]="bean.readOnly">
                            <span [ngbTooltip]="bean.readOnlyNote">&nbsp;<i class="fa fa-info"></i></span>
                        </ng-template>
                        <ng-template [ngIf]="!bean.readOnly">
                            <a class="naked muted" (click)="onEditEmployeeSchedule(bean)">&nbsp;<i class="fad fa-pencil" style="--fa-primary-color: #374981; --fa-secondary-color: #374981;"></i></a>
                        </ng-template>
                        <ng-template [ngIf]="!bean.readOnly">
                            <a class="naked muted" (click)="onDeleteEmployeeSchedule(bean)">&nbsp;<i class="fa fa-close"></i></a>
                        </ng-template>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</ng-template>

<ng-template [ngIf]="schedules.length==0 && isAfterToday()">
    <div class="workshift show-over" style="text-align: center;" (click)="onAddEmployeeSchedule()" droppable (onDrop)="onItemDrop($event)">
        <ng-template [ngIf]="hasPlannedSchedules()">
            <div class="muted" style="float: right"><i class="fa fa-certificate"></i></div>
        </ng-template>
    </div>
</ng-template>